export const dayjsLocales = {
  EN_GB: 'en-gb',
}
